module.exports = __webpack_public_path__ + "img/list05.1b1091af.jpg";